import React from 'react';
import './PageLoader.css';

const PageLoader = (props) => {
  return (
    <div className='page-loader-container'>
      <div className='page-loader'>
        <div />
        <div />
        <div />
        <div />
        <React.Fragment>
          <span>{props.text ? props.text : ''}</span>
          <span>{props.loading}</span>
        </React.Fragment>
      </div>
    </div>
  );
};

export default PageLoader;
